<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t("department.departments") }}</h2>
    </div>
    <el-card
      v-if="checkRole(['Admin'])"
      class="box-card filter-card just-for-admin"
    >
      <div slot="header" class="clearfix">
        <span>{{ $t("general.filter") }}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="initSearch"
        >{{ $t("general.init") }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio
          v-model="activeList"
          label="actives"
          border
          @change="getSubDepartmentsList('indexactive')"
        >{{ $t("general.F_actives") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="desactives"
          border
          @change="getSubDepartmentsList('indexdesactive')"
        >{{ $t("general.F_desactives") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="disponibles"
          border
          @change="handleFilterDepartments"
        >{{ $t("general.disponibles") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="corbeille"
          class="danger-radio"
          border
          @change="getSubDepartmentsList('indexinvisible')"
        >{{ $t("general.corbeille") }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input
          v-model="query.keyword"
          clearable
          :placeholder="$t('general.keyword')"
          class="wd-200 mr-15 filter-item"
          @keyup.enter.native="handleFilterDepartments"
        />
        <el-select
          v-model="query.province_id"
          class="filter-item"
          filterable
          clearable
          :placeholder="$t('province.province')"
          @change="handleFilterDepartments"
        >
          <el-option
            v-for="(province, index) in provinces"
            :key="index"
            :label="province.name | uppercaseFirst"
            :value="province.id"
          />
        </el-select>
        <el-button
          v-waves
          class="mr-15 filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilterDepartments"
        >
          {{ $t("general.search") }}
        </el-button>
        <el-button
          v-waves
          :loading="downloading"
          class="filter-item"
          type="primary"
          icon="el-icon-download"
          @click="handleDownload"
        >
          {{ $t("general.export") }}
        </el-button>
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-upload"
          @click="handleImportDepartments"
        >
          {{ $t('general.import') }}
        </el-button>
        <input
          ref="fileInput"
          type="file"
          style="display: none"
          accept=".xlsx, .xls"
          @change="onFileChange"
        >

        <el-button
          v-if="checkPermission(['create department'])"
          class="mr-15 filter-item"
          type="primary"
          icon="el-icon-plus"
          @click="handleCreateDepartment"
        >
          {{ $t("general.add") }}
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column align="center" :label="$t('general.reference')" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.ref }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('department.name')">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('province.province')" width="200">
          <template slot-scope="scope">
            <!-- <span>
              {{ provinces.find((province) => province.id == scope.row.province_id)?.name??'' }}
            </span> -->
            <span>{{ scope.row.province.name }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="
            activeList != 'corbeille' && checkPermission(['activate department'])
          "
          align="center"
          :label="$t('general.status')"
          width="150"
        >
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              :disabled="!scope.row.is_visible"
              @change="setDepartmentStatus(scope.row.id, 'active')"
            />
          </template>
        </el-table-column>

        <el-table-column
          v-if="
            checkRole(['Admin']) && (activeList == 'corbeille' || query.keyword)
          "
          align="center"
          :label="$t('general.restaurer')"
          width="100"
        >
          <template slot-scope="scope">
            <el-switch
              v-if="!scope.row.is_visible"
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_visible"
              @change="setDepartmentStatus(scope.row.id, 'visible')"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkPermission(['edit department', 'hide department', 'delete department'])"
          align="center"
          :label="
            1 == 1 ? $t('general.actions') : $t('general.suppressionDefinitive')
          "
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.is_visible && checkPermission(['edit department'])"
              type="primary"
              size="small"
              icon="el-icon-view"
              style="margin-right: 10px"
              @click="handleEditDepartment(scope.row.id)"
            />
            <el-button
              v-if="checkPermission(['hide department', 'delete department'])"
              slot="reference"
              type="danger"
              size="small"
              icon="el-icon-delete"
              style="margin-right: 10px"
              @click="
                handleDeleteDepartment(
                  scope.row.id,
                  scope.row.is_visible,
                  scope.row.name
                )
              "
            />
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="query.page"
        :limit.sync="query.limit"
        @pagination="getDepartmentsList"
      />

      <!-- ======= DEPARTMENT FORM ======= -->
      <el-dialog
        :title="
          editing
            ? $t('department.edit') + ' ' + currentDepartment.name
            : $t('department.AddDepartment')
        "
        :visible.sync="dialogCreateDepartment"
        :before-close="handleCloseDepartmentCreateDraw"
        :loading="departmentCreating"
        width="50%"
      >
        <div class="content-inputs">
          <el-form
            ref="departmentForm"
            :rules="rules"
            :model="currentDepartment"
            label-position="left"
          >
            <el-form-item
              :label="$t('province.selectProvinceTitle')"
              prop="province_id"
            >
              <el-select
                v-model="currentDepartment.province_id"
                class="filter-item w-100"
                :placeholder="$t('province.province')"
              >
                <el-option
                  v-for="(province, index) in provinces"
                  :key="index"
                  :label="province.name | uppercaseFirst"
                  :value="province.id"
                  :disabled="!province.is_active"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('department.name')" prop="name">
              <el-input v-model="currentDepartment.name" />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align: right">
            <el-button plain type="danger" @click="dialogCreateDepartment = false">
              {{ $t("permission.cancel") }}
            </el-button>
            <el-button
              type="primary"
              :loading="departmentCreating"
              @click="editing ? updateDepartment() : createDepartment()"
            >
              {{ departmentCreating ? $t("general.saving") : $t("general.save") }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <!-- ======= END DEPARTMENT FORM ======= -->
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
const departmentResource = new Resource('departments');
const provinceResource = new Resource('provinces');
export default {
  name: 'DepartmentsList',
  components: { Pagination },
  directives: { waves, permission, role },
  data() {
    return {
      provinces: [],
      list: null,
      total: 0,
      loading: false,
      downloading: false,
      departmentCreating: false,
      editing: false,
      activeList: 'disponibles',
      query: {
        page: 1,
        limit: this.$limit,
        keyword: '',
      },
      currentDepartment: {},
      dialogCreateDepartment: false,
      currentDepartmentId: 0,
      rules: {
        name: [
          {
            required: true,
            message: this.$t('department.NameRequired'),
            trigger: 'blur',
          },
        ],
        province_id: [
          {
            required: true,
            message: this.$t('province.provinceRequired'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getProvincesList();
    this.resetNewDepartment();
    this.getDepartmentsList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array) {
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseDepartmentCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    cancelDepartmentForm() {
      this.$refs.DepartmentCreationDrawer.closeDrawer();
    },
    initSearch() {
      this.query = {
        page: 1,
        limit: this.$limit,
        keyword: '',
      };
      this.activeList = 'disponibles';
      this.handleFilterDepartments();
    },
    async getDepartmentsList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await departmentResource.list(this.query);
      this.list = data;
      this.list.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    async getSubDepartmentsList(subUrl) {
      this.loading = true;
      const { data } = await departmentResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterDepartments() {
      this.query.page = 1;
      this.getDepartmentsList();
    },
    handleCreateDepartment() {
      this.editing = false;
      this.resetNewDepartment();
      this.dialogCreateDepartment = true;
      this.$nextTick(() => {
        this.$refs['departmentForm'].clearValidate();
      });
    },
    handleEditDepartment(id) {
      this.editing = true;
      this.resetNewDepartment();
      this.currentDepartment = this.list.find((abonne) => abonne.id === id);
      this.dialogCreateDepartment = true;
      this.$nextTick(() => {
        this.$refs['departmentForm'].clearValidate();
      });
    },
    async setDepartmentStatus(id, type) {
      const data = await departmentResource.get('toogle_' + type + '/' + id);
      if (data.success) {
        this.$message({
          type: 'success',
          message: this.$t('general.statusUpdated'),
        });
        this.initSearch();
      } else {
        this.$message({
          type: 'danger',
          message: this.$t('general.statusUpdateError'),
        });
      }
    },
    handleDeleteDepartment(id, visible, name) {
      this.$confirm(
        this.$t('department.deleteWarn') +
          ' ' +
          name +
          '. ' +
          this.$t('general.deleteContinue'),
        'Warning',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: this.$t('general.cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          if (
            !visible &&
            (checkRole(['Admin']) || checkPermission(['delete department']))
          ) {
            this.$swal({
              title: this.$t('general.SureQuestion'),
              text: this.$t('general.irrversibleMessage'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.$t('general.ouiSupprimer'),
            }).then((result) => {
              if (result.isConfirmed) {
                departmentResource
                  .destroy(id)
                  .then((response) => {
                    this.$message({
                      type: 'success',
                      message: this.$t('department.suppressionEffectue'),
                    });
                    this.initSearch();
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            });
          } else {
            this.setDepartmentStatus(id, 'visible');
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general.suppressionAnnule'),
          });
        });
    },
    createDepartment() {
      this.$refs['departmentForm'].validate((valid) => {
        if (valid) {
          this.departmentCreating = true;
          departmentResource
            .store(this.currentDepartment)
            .then(async(response) => {
              this.$message({
                message:
                  this.$t('department.NewDepartment') +
                  ' ' +
                  this.currentDepartment.name +
                  ' ' +
                  this.$t('department.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentDepartmentId = response.data.id;
              this.resetNewDepartment();
              this.dialogCreateDepartment = false;
              this.handleFilterDepartments();
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.departmentCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    updateDepartment() {
      this.$refs['departmentForm'].validate((valid) => {
        if (valid) {
          this.departmentCreating = true;
          departmentResource
            .update(this.currentDepartment.id, this.currentDepartment)
            .then((response) => {
              this.resetNewDepartment();
              this.handleFilterDepartments();
              this.$message({
                message: this.$t('department.isupdatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.dialogCreateDepartment = false;
              this.editing = false;
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.departmentCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    resetNewDepartment() {
      this.currentDepartment = {
        name: '',
      };
    },
    async getProvincesList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await provinceResource.list(this.query);
      this.provinces = data;
      this.provinces.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'ID',
          this.$t('department.name'),
          this.$t('province.province'),
        ];
        const filterVal = ['id', 'name', 'province_id'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:
            'Departments list GEOSANTE_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    // Importation
    handleImportDepartments() {
      // Ouvre le sélecteur de fichier
      this.$refs.fileInput.click();
    },

    async onFileChange(event) {
      console.log('onFileChange');
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      try {
        // Utilisez XLSX pour lire le fichier Excel
        const XLSX = await import('xlsx');
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          // Supposons que les données sont dans la première feuille
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convertir les données en JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: ['code', 'name', 'province'],
            range: 1,
          });

          // Valider et envoyer les données au backend
          this.uploadDepartments(jsonData);
        };

        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.error('Erreur lors de la lecture du fichier Excel:', error);
        this.$message.error(this.$t('general.importError'));
      }
    },

    async uploadDepartments(departments) {
      try {
        // Envoyer les données au backend
        const response = await departmentResource.substore(
          '/import',
          departments
        );

        if (response.success) {
          this.$message.success(this.$t('department.importSuccess'));
          this.getDepartmentsList(); // Rafraîchir la liste des départements
        } else {
          this.$message.error(this.$t('department.importError'));
        }
      } catch (error) {
        console.error('Erreur lors de l\'importation des municipalités:', error);
        this.$message.error(this.$t('department.importError'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.half-right {
  width: 70% !important;
  float: none !important;
  text-align: left !important;
  padding: 10px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
